module.exports = __webpack_public_path__ + "img/credsis-loading.313bbde7.svg";